<template>
  <div>
    <img
      v-if="lang"
      style="border-radius: 6px; overflow: hidden;"
      :src="'/img/kontakt_' + lang + '.jpg'"
    />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ContactBanner',

  computed: {
    ...mapFields(Object.keys(state)),
  },
}
</script>
